import React from "react";

import {
  Badge,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components";

import { TCampaignUploadPreviewRow } from "../../campaign-upload.types";

interface ICampaignUploadPreviewTableProps {
  rows: TCampaignUploadPreviewRow[];
  title: string;
  noRowsLabel: string;
  headers: {
    line: string;
    company: string;
    first_name: string;
    last_name: string;
    email: string;
    phone: string;
    phone_2: string;
    document_number: string;
    status: string;
    reason: string;
  };
  statusLabels: {
    valid: string;
    invalid: string;
    duplicate: string;
  };
}

export const CampaignUploadPreviewTable: React.FC<
  ICampaignUploadPreviewTableProps
> = ({ rows, title, noRowsLabel, headers, statusLabels }) => {
  const statusStyleMap: Record<string, string> = {
    valid:
      "bg-emerald-50 text-emerald-700 border border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-800",
    invalid:
      "bg-rose-50 text-rose-700 border border-rose-200 dark:bg-rose-950 dark:text-rose-300 dark:border-rose-800",
    duplicate:
      "bg-amber-50 text-amber-700 border border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-800",
  };

  const statusLabelMap: Record<string, string> = {
    valid: statusLabels.valid,
    invalid: statusLabels.invalid,
    duplicate: statusLabels.duplicate,
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle>{title}</CardTitle>
      </CardHeader>
      <CardContent>
        {rows.length === 0 ? (
          <p className="text-sm text-muted-foreground">{noRowsLabel}</p>
        ) : (
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>{headers.line}</TableHead>
                <TableHead>{headers.company}</TableHead>
                <TableHead>{headers.first_name}</TableHead>
                <TableHead>{headers.last_name}</TableHead>
                <TableHead>{headers.email}</TableHead>
                <TableHead>{headers.phone}</TableHead>
                <TableHead>{headers.phone_2}</TableHead>
                <TableHead>{headers.document_number}</TableHead>
                <TableHead>{headers.status}</TableHead>
                <TableHead>{headers.reason}</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.map((row) => (
                <TableRow key={`${row.line}-${row.phone}-${row.status}`}>
                  <TableCell>{row.line}</TableCell>
                  <TableCell>{row.company || "-"}</TableCell>
                  <TableCell>{row.first_name || row.name?.split(" ")[0] || "-"}</TableCell>
                  <TableCell>{row.last_name || row.name?.split(" ").slice(1).join(" ") || "-"}</TableCell>
                  <TableCell>{row.email || "-"}</TableCell>
                  <TableCell>{row.phone || "-"}</TableCell>
                  <TableCell>{row.phone_2 || "-"}</TableCell>
                  <TableCell>{row.document_number || "-"}</TableCell>
                  <TableCell>
                    <Badge className={statusStyleMap[row.status]}>
                      {statusLabelMap[row.status]}
                    </Badge>
                  </TableCell>
                  <TableCell>{row.reason ?? "-"}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </CardContent>
    </Card>
  );
};
